export function sanitizeKeyboardBetValue(value) {
  return String(value ?? '').replace(/\D/g, '');
}

export function parseKeyboardBetValue(value) {
  const digits = sanitizeKeyboardBetValue(value);
  if (!digits) return 0;
  const parsed = Number.parseInt(digits, 10);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : 0;
}

export function saveKeyboardBetDraft(values, index, draft) {
  const next = Array.from({ length: 5 }, (_, itemIndex) => parseKeyboardBetValue(values?.[itemIndex]));
  if (!Number.isInteger(index) || index < 0 || index >= next.length) return next;
  next[index] = parseKeyboardBetValue(draft);
  return next;
}

export function resolveBetEnterAction({ overlay = '', inputFocused = false } = {}) {
  if (inputFocused) return 'open-confirm';
  if (overlay === 'confirm') return 'submit';
  if (overlay === 'history') return 'close-history';
  return 'none';
}
